/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Valid/view.blocks to change it.
import Button from 'DesignSystem/Button/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'



/** @type {import('Simple/types.js').View} */
export default function Valid({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientPhone/Status/Valid",
  onClick
  
}) {
  return (<React.Fragment
>
<Button
  viewPath={`${viewPath}/Button`}
 onClick={onClick}
 text="Press Enter To Continue"
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="enter"
 onPress={onClick}
/>
{children}
</React.Fragment>)
}